import { render, staticRenderFns } from "./LoginClient.vue?vue&type=template&id=05bdf030&scoped=true"
import script from "./LoginClient.vue?vue&type=script&lang=js"
export * from "./LoginClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bdf030",
  null
  
)

export default component.exports